var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableauLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 98,
    viewBox: "0 0 100 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2637 66.09H52.7363V51.2939H66.5008V46.033H52.7363V31.2368H47.2637V46.033H33.665V51.2939H47.2637V66.09Z",
    fill: "#E8762D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8901 87.4615H26.5335V74.3093H38.8055V70.1993H26.5335V56.8827H21.8901V70.1993H9.61816V74.3093H21.8901V87.4615Z",
    fill: "#C72037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4656 39.9499H78.109V26.7977H90.5468V22.8521H78.109V9.53552H73.4656V22.8521H61.1937V26.7977H73.4656V39.9499Z",
    fill: "#5B879B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0923 97.8194H52.0724V88.4485H60.5301V84.996H52.0724V75.6251H48.0923V84.996H39.8005V88.4485H48.0923V97.8194Z",
    fill: "#5C6692"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0559 39.9499H26.3677V26.6333H38.8055V22.8521H26.3677V9.53552H22.0559V22.8521H9.61816V26.6333H22.0559V39.9499Z",
    fill: "#EB9129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5622 59.6782H91.5423V50.4717H100V46.8548H91.5423V37.6483H87.5622V46.8548H79.2704V50.4717H87.5622V59.6782Z",
    fill: "#5C6692"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4656 87.4615H78.109V74.3093H90.5468V70.1993H78.109V56.8827H73.4656V70.1993H61.1937V74.3093H73.4656V87.4615Z",
    fill: "#1F457E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8672 11.8369V9.04211H51.5753V0H48.5902V9.04211H40.2984V11.8369H48.5902V20.879H51.5753V11.8369H59.8672ZM8.29185 59.0203H11.2769V49.9782H19.5688V47.1834H11.2769V38.3057H8.29185V47.1834H0V50.1426L8.29185 49.9782V59.0203Z",
    fill: "#7199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableauLogo);
export default __webpack_public_path__ + "static/media/tableau_logo.154b67050a2b5d117ed86ae2d90083c2.svg";
export { ForwardRef as ReactComponent };